<template>
  <div class="content-wrapper" :data-ref="REFS.CONTENT_WRAPPER">
    <slot />
  </div>
</template>

<script>
import { REFS } from '@/utils/enums/external-refs'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

export default {
  name: 'ALayoutContentContainer',
  mixins: [hydrationHelpers],
  data() {
    return {
      REFS
    }
  }
}
</script>

<style lang="scss" scoped>
$border-size-desktop-full-hd: 1px;

.content-wrapper {
  max-width: $desktop-container;
  border: none;
  position: relative;
  min-width: 320px;
  margin: 0 auto;
  height: 100%;
  background: $c--black;

  // Please, check on real mobile/tablet devices before removing.
  // This is to ensure absolutely positioned objects with negative
  // left/right margins don't cause horizontal scroll to appear.
  // Example of problematic case: gradient background in top section.
  @include desktop-md {
    overflow-x: hidden;
  }

  $padding: (
    $above-desktop-xl: $desktop-header-height $padding-x-desktop-full-hd 0,
    $desktop-sm: $desktop-header-height $padding-x-desktop-sm 0,
    $tablet: $mobile-header-height $padding-x-desktop-sm 0,
    $mobile: $mobile-header-height $padding-x-mobile 0
  );

  @include setStyleByBreakpoint('padding', $padding);

  @include desktop-sm {
    border: none;
  }
}
</style>
